import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const ObservationsService = {
  observations: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/observations",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/observations/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (network) {
    const requestData = {
      method: "post",
      url: "/api/management/observations/update",
      data: network
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/observations",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default ObservationsService;
